import React from 'react';
import {classes, stylesheet} from 'typestyle';
import {TProvider} from '../../i18n/i18n';
import {LightGreyColor} from '../../styles/colors';

interface MinMaxFilterProps {
    updateMinValue: (value: string) => void;
    updateMaxValue: (value: string) => void;
    values: {
        min: string;
        max: string;
    };
}

export default function MinMaxFilter({values, updateMaxValue, updateMinValue}: MinMaxFilterProps) {
    return (
        <div style={{marginBottom: 5}}>
            <div style={{height: 30}}>
                <TProvider>
                    {(t) => (
                        <input
                            value={values.min}
                            id="minInput"
                            onChange={(e) => updateMinValue(e.currentTarget.value)}
                            className={minMaxCss.minMaxInput}
                            type="text"
                            placeholder={t('table:min')}
                        />
                    )}
                </TProvider>
                -
                <TProvider>
                    {(t) => (
                        <input
                            id="maxInput"
                            value={values.max}
                            onChange={(e) => updateMaxValue(e.currentTarget.value)}
                            className={classes(minMaxCss.minMaxInput, 'right')}
                            type="text"
                            placeholder={t('table:max')}
                        />
                    )}
                </TProvider>
            </div>
        </div>
    );
}

const minMaxCss = stylesheet({
    minMaxInput: {
        border: '1px solid ' + LightGreyColor,
        borderRadius: 2,
        textAlign: 'center',
        width: 60,
        float: 'left',
        padding: 2,
        height: 30,
        $nest: {
            '&.right': {
                float: 'right',
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/MinMaxFilter.tsx